module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/sa-icon-download_ed04dff.png";